import React , { useState , useEffect } from 'react'
import Container from '@mui/material/Container';
import { useNavigate } from "react-router-dom"

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import QrCodeIcon from '@mui/icons-material/QrCode';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

import UnpublishedIcon from '@mui/icons-material/Unpublished';
import Box from '@mui/material/Box';
// ventana de Dialogo
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
//
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
//
import { useStore } from './store/comercioStore' ;

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function ComerciosTodos() {
  const { asigna ,tipo} = useStore();
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [comercios,setComercios] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [openSucursales,setOpenSucursales] = React.useState(false);
  const [openEstado, setOpenEstado] = React.useState(false);
  const [estado, setEstado] = React.useState(false);
  const [openMsgOk, setOpenMsgOk] = React.useState(false);
  const [openMsgError, setOpenMsgError] = React.useState(false);
  const [mensaje, setMensaje] = React.useState('');
  const [titulo, setTitulo] = React.useState('');

  const [id, setId] = React.useState(0);
  const [rz, setRz] = React.useState('');
  const [detalle, setDetalle] = React.useState('');
  //
  const [centrosComerciales,setCentrosComerciales] = useState([]);
  const [sucursales,setSucursales] = useState([]);
  
  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  //const filteredData = comercios;
  const filteredData = comercios.filter(item => item.razon_social?.toLowerCase().includes(filter.toLowerCase())
  || item.estado?.toLowerCase().includes(filter.toLowerCase()));
  
  const getComercios = () => {
    setLoading(true);
    const baseURL = process.env.REACT_APP_SERVER_PATH+'comerciosTodos';
    if (tipo === '3') {
          // si es usuario camara => filtrar por su Provincia / Localidad
          // definir los estados generales de la provincia / localidad
    const baseURL = process.env.REACT_APP_SERVER_PATH+'comerciosTodos';
    }
   

    fetch(`${baseURL}`)
     .then(res => res.json())
    .then(
      (result) => {
      setComercios(result);
      setLoading(false);
      },
      (error) => {
      }
    )
   }

   const handleDeleteClick = async (id,rz) => {
      setId(id);
      setRz(rz);
      setOpen(true);
    };

    const handleEstadoClick = async (id,rz,titulo) => {
      if (titulo === 'Aprueba') {
          setEstado(true);
        }
      else
          {setEstado(false);}  
      setId(id);
      setRz(rz);
      setTitulo(titulo);
      setOpenEstado(true);
    };     

   const handleDelete = async() => {
    setOpen(false);
      const postData = {
      id : id
    };
    try {
      const baseURL = process.env.REACT_APP_SERVER_PATH + 'delComercio/'+id;
      const res = await fetch(`${baseURL}`, {
        method: "delete",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": "token-value",
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify(postData),
      });
     
      if (( res.status === 200 ) || ( res.status === 204 ) || ( res.status === 304 )) {
         getComercios(); 
         setMensaje('Eliminación Correcta');
         handleClickMsg();
            }
      else
          if ( res.status === 500 ) {
            setMensaje('Error al eliminar');
            setOpenMsgError(true);
              console.log('Error al eliminar el comercio!');
              } 
          else    
              { 
                setMensaje('Error al eliminar');
                setOpenMsgError(true);}
          } catch (err) {
            console.log(err.message)
          }
  };
  // 
  const handleSubmit = async(event) => {
    event.preventDefault();
    setEstado(true);
    setOpen(false);
      const postData = {
      fecha : new Date(),
      detalle : detalle,
      estate : estado,
      id : id
    };
    try {
      const baseURL = process.env.REACT_APP_SERVER_PATH + 'updateComercio';
      const res = await fetch(`${baseURL}`, {
        method: "put",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": "token-value",
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify(postData),
      });
     
      if (( res.status === 200 ) || ( res.status === 204 ) || ( res.status === 304 )) {
          setOpenEstado(false);
          setDetalle('');
          getComercios(); 
          setMensaje('Modificación Correcta');
          handleClickMsg();
          }
      else
          if ( res.status === 500 ) {
             setMensaje('Error al modificar');
             setOpenMsgError(true);
             console.log('Error al eliminar el comercio!');
              } 
          else    
              { 
                setMensaje('Error al eliminar');
                setOpenMsgError(true);}
          } catch (err) {
            console.log(err.message)
          }
  };

  const  handleCloseSucursales = () => {
    setOpenSucursales(false);
  }

  const handleClose = () => {
    setOpen(false);
  };
  //
  const handleEstadoClose = () => {
    setOpenEstado(false);
  };

  const handleClickMsg = () => {
    setOpenMsgOk(true);
  };

  const handleEdit = (item) => {
    {  
      asigna(item);
      navigate('/editComercio')}
  };

  const getSucursales = (id) => {
    const baseURL = process.env.REACT_APP_SERVER_PATH+'getSucursales/'+id;
    fetch(`${baseURL}`)
    .then(res => res.json())
    .then(
          (result) => {
              setSucursales(result);
          },

          (error) => {

          }
    )
   }

  const getCentrosComerciales = () => {
    const baseURL = process.env.REACT_APP_SERVER_PATH+'getCentrosComerciales';
    fetch(`${baseURL}`)
    .then(res => res.json())
    .then(
      (result) => { setCentrosComerciales(result) 
      },
      (error) => {
      }
    )
   }

  const handleSucursales = (id) => {
    getSucursales(id); 
      
      setOpenSucursales(true);
  };

  const handleCloseMsg = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenMsgOk(false);
  };
  //
  const handleClickMsgError = () => {
    setOpenMsgError(true);
  };

  const handleCloseMsgError = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenMsgError(false);
  };

  const handleQrClick = (valor) => {
  //  setLoading(true);
        // toma la URL actual
        let cadena = window.location.href;
        // le quita: menucomercio 
        //let cadena2 = cadena.split("menucomercio").join("");
        // le quita: menuucip
        let cadena2 = cadena.split("menuucip").join("");

        // arma el llamado a la API con el link del QR 
        window.open(process.env.REACT_APP_SERVER_PATH+'download/?link='+cadena2+"inscripciones/"+valor, "_blank");
  //      setLoading(false);
   }

   useEffect(() => {
    getComercios(); 
},[])
  
  return (<>
      {/* VENTANA DE OPCIONES DE ESTADO */}
      <Dialog
        open={openEstado}
        onClose={handleEstadoClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description-estado"
      >
         <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
        <DialogTitle id="alert-dialog-title">
          {"¿"+titulo+" al comercio "+rz+"?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description-estado">
           Complete una descripción del registro
          </DialogContentText>
         
          <TextField 
              id="standard-basic" 
              label="Standard" 
              variant="standard" 
              value = {detalle}
              onChange = {(e) => setDetalle(e.target.value)}
              required
              sx={{ mt: 2, mb: 2 }}/>
              
        </DialogContent>
        <DialogActions>
          <Button type = "submit" color ="primary" variant = "contained" onClick={handleClose}>Aceptar</Button>
          <Button color ="secondary" variant = "contained" onClick={handleEstadoClose} autoFocus>
            Cancelar
          </Button>
        </DialogActions>
        </Box>
      </Dialog>
    {/* VENTANA DE ELIMINACION */}
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'¿Confirma ELIMINAR al comercio '+rz+'?'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Esta acción no se puede revertir
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="contained" onClick={handleDelete}>Aceptar</Button>
          <Button color="secondary" variant="contained" onClick={handleClose} autoFocus>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
        {/* VENTANA DE SUCURSALES */}
      <Dialog
        open={openSucursales}
        onClose={handleCloseSucursales}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {''}
        </DialogTitle>
        <DialogContent>
        <TableContainer component={Paper} sx={{ mt: 3, mb: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
              <TableCell>ID</TableCell>
                <TableCell>Calle</TableCell>
                <TableCell>Numero</TableCell>
                <TableCell>Centro comercial</TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {sucursales.map((item,index)=>(
                <TableRow key={index + 1}>
                   <TableCell>{item.idcomerciosucursal}</TableCell>
                  <TableCell>{item.calle}</TableCell>
                  <TableCell>{item.numero}</TableCell>
                  <TableCell>{item.descripcion}</TableCell>
                  <TableCell >
                <Button color="info" variant="outlined" startIcon={<QrCodeIcon />} 
                onClick={() => handleQrClick(item.idcomerciosucursal)}>Generar</Button>
              </TableCell >
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="contained" onClick={handleCloseSucursales}>Cerrar</Button>

        </DialogActions>
      </Dialog>
    <Container component="main" maxWidth="xl">
     <h2>Opciones sobre Comercios Registrados</h2>
      
      <TextField id="filtro" label="Filtro" variant="outlined"
      value={filter} onChange={handleFilterChange} placeholder="Razón Social o Estado"
      sx={{ mt: 2, mb: 2 }} />
      
      {loading ? (
          <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      ) : (  
        <TableContainer component={Paper} style={{ maxWidth: '100%', overflowX: 'auto' }}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        < TableHead>
          <TableRow>
            <TableCell >ID</TableCell >
            <TableCell >Razon social</TableCell >
            <TableCell >E-Mail</TableCell >
            <TableCell >Estado</TableCell >
            <TableCell ></TableCell >
            <TableCell >Acciones</TableCell >
          </TableRow>
        </ TableHead>
        <TableBody>
        {filteredData.map((item) => (
            <TableRow
              key={item.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell >{item.id}</TableCell >
              <TableCell >{item.razon_social}</TableCell >
              <TableCell >{item.email}</TableCell >
              <TableCell >{item.estado}</TableCell >
              <TableCell >
              <Button color="success" variant="outlined" startIcon={<CheckIcon />} 
              onClick={() => handleEstadoClick(item.id,item.razon_social,"Aprueba")}>Aprobar</Button>

              </TableCell >
              <TableCell >
              <Button color="secondary" variant="outlined" startIcon={<UnpublishedIcon />} 
              onClick={() => handleEstadoClick(item.id,item.razon_social,"Desaprueba")}>Desaprobar</Button>

              </TableCell >
              { tipo != '3'?(
              <TableCell >
                <Button color="error" variant="outlined" startIcon={<DeleteIcon />} 
                onClick={() => handleDeleteClick(item.id,item.razon_social)}>Eliminar</Button>
              </TableCell >):(<></>)
              }
              <TableCell >
                <Button color="info" variant="outlined" startIcon={<EditIcon />} 
                onClick={() => handleEdit(item.id)}>Editar</Button>
              </TableCell >
              <TableCell >
                <Button color="warning" variant="outlined" startIcon={<RemoveRedEyeIcon />} 
                onClick={() => handleSucursales(item.id)}>Sucursales</Button>
              </TableCell >              
              </TableRow>
          ))}          
        </TableBody>
      </Table>
      </TableContainer>
       )}
     
      <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar open={openMsgOk} autoHideDuration= {6000} onClose={handleCloseMsg}>
        <Alert onClose={handleCloseMsg} severity="success" sx={{ width: '100%' }}>
          {mensaje}
        </Alert>
      </Snackbar>
    </Stack>

    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar open={openMsgError} autoHideDuration={6000} onClose={handleCloseMsgError}>
        <Alert onClose={handleCloseMsgError} severity="error" sx={{ width: '100%' }}>
        {mensaje}
        </Alert>
      </Snackbar>
    </Stack>

    </Container>
   </> )
}

export default ComerciosTodos